import Navigation from "../components/Navigation/Navigation";

const NavigationPage = () => {
  return <Navigation currentNavigationName={'NavigationPage'}/>;
};

export default NavigationPage;
